import React from 'react';

import { FormGroup, Col, Form, ControlLabel } from 'react-bootstrap';
import ScheduledEvents from './ScheduledEvents';
import ModalWrapper from './ModalWrapper';
import Select from '../atoms/forms/Select';
import InfoTooltipIcon from '../../assets/InfoTooltipIcon';

export default function DisplayRowSelectWithReason({
  reasonValue = '',
  options = {},
  reasonsToChange = [],
  value = '',
  tooltip = '',
  ...props
}) {
  const formattedValue = value === 'false' || !value ? 'false' : 'true';

  const formattedOptions =
    Object.entries(options).map(([val, label]) => ({
      label,
      value: val,
    })) || [];

  const getReasonValue = () => {
    // make reason case-insensitive
    // will be useful while handling bulk updates using CSV

    for (let i = 0; i < reasonsToChange.length; i++) {
      if (reasonValue.toLowerCase() === reasonsToChange[i].toLowerCase()) {
        return reasonsToChange[i];
      }
    }
    return '';
  };

  return (
    <tr>
      <td>
        {props.prettyName}
        {tooltip ? <InfoTooltipIcon tooltipText={tooltip} /> : ''}
      </td>
      <td className="detailColumn" onClick={props.handleOpen}>
        {props.displayValue}
      </td>
      <ModalWrapper
        show={props.edit}
        title={props.prettyName}
        handleClose={props.handleClose}
        handleSave={props.handleSave}
        handleSchedule={props.handleSchedule}
      >
        <Form horizontal>
          <FormGroup controlId="formHorizontalAllocation">
            <Col componentClass={ControlLabel} sm={2}>
              {props.prettyName}
            </Col>
            <Col sm={10}>
              <Select
                name={props.id}
                value={formattedValue}
                onChange={props.handleChange}
                placeholder={props.placeholder}
                required
                options={formattedOptions}
              />
            </Col>
          </FormGroup>
          {Array.isArray(reasonsToChange) && (
            <FormGroup controlId="formHorizontalReason">
              <Col componentClass={ControlLabel} sm={2}>
                Reason for Change
              </Col>
              <Col sm={10}>
                <Select
                  name={props.id}
                  placeholder="Choose Reason"
                  onChange={props.handleReasonChange}
                  value={getReasonValue()}
                  required
                  options={reasonsToChange.map((r) => ({
                    label: r,
                    value: r,
                  }))}
                />
              </Col>
            </FormGroup>
          )}
          <font className="mandatory">{props.errorString}</font>
        </Form>
        <ScheduledEvents
          events={props.events}
          id={props.id}
          deleteScheduleAction={props.deleteScheduleAction}
        />
      </ModalWrapper>
    </tr>
  );
}
